export const emojiDefaults = {
  default: ":sunglasses:", // 😎
  stages: {
    default: ":sunglasses:", // 😎
    reserved: ":grey_heart:", // 🩶
    disqualified: ":no_entry:", // 🚫
  },
  jobs: {
    default: ":technologist:", // 👨‍💻
    leaps: ":four_leaf_clover:", // 🍀
    sunflowers: ":sunflower:", // 🌻
    roses: ":rose:", // 🌹
    tulips: ":tulip:", // 🌷
    dog: ":dog:", // 🐶
    lion: ":lion_face:", // 🦁
    fox: ":fox_face:", // 🦊
    cow: ":cow_face:", // 🐮
    mouse: ":mouse:", // 🐭
    koala: ":koala:", // 🐨
    rabbit: ":rabbit:", // 🐰
    owl: ":owl:", // 🦉
    octopus: ":octopus:", // 🐙
    blowfish: ":blowfish:", // 🐡
    rosette: ":rosette:", // 🎀
    beetle: ":beetle:", // 🪲
    cherry_blossom: ":cherry_blossom:", // 🌸
    shamrock: ":shamrock:", // ☘️
    four_leaf_clover: ":four_leaf_clover:", // 🍀
    lemon: ":lemon:", // 🍋
    pineapple: ":pineapple:", // 🍍
    apple: ":apple:", // 🍎
    green_apple: ":green_apple:", // 🍏
    mushroom: ":mushroom:", // 🍄
    tennis: ":tennis:", // 🎾
    soccer: ":soccer:", // ⚽
    eight_ball: ":8ball:", // 🎱
    teddy_bear: ":teddy_bear:", // 🧸
    dart: ":dart:", // 🎯
    tiger: ":tiger:", // 🐅
    male_astronaut: ":male_astronaut:", // 👨‍🚀
    artist: ":artist:", // 🎨
    technologist: ":technologist:", // 👨‍💻
    student: ":student:", // 👨‍🎓
    man_gesturing_ok: ":man_gesturing_ok:", // 👨‍🦯
    squid: ":squid:", // 🦑
    doughnut: ":doughnut:", // 🍩
    cookie: ":cookie:", // 🍪
    coffee: ":coffee:", // ☕
    popcorn: ":popcorn:", // 🍿
    hamburger: ":hamburger:", // 🍔
    cherries: ":cherries:", // 🍒
    butterfly: ":butterfly:", // 🦋
    t_rex: ":t_rex:", // 🦖
  },
  time_off: {
    default: ":desert_island:", // 🏝️
    balloon: ":balloon:", // 🎈
    tada: ":tada:", // 🎉
    earth_africa: ":earth_africa:", // 🌍
    world_map: ":world_map:", // 🗺️
    compass: ":compass:", // 🧭
    mountain: ":mountain:", // ⛰️
    camping: ":camping:", // ⛺
    desert_island: ":desert_island:", // 🏝️
    beach_with_umbrella: ":beach_with_umbrella:", // 🏖️
    seat: ":seat:", // 💺
    airplane: ":airplane:", // ✈️
    boat: ":boat:", // ⛵
  },
  team: {
    default: ":rocket:", // 🚀
  },
  survey: {
    default: ":dog:", // 🐶
  },
  surveyTemplate: {
    default: ":memo:", // 📝
  },
  performanceReview: {
    default: ":dart:", // 🎯
  },
  performanceReviewTemplate: {
    default: ":memo:", // 📝
  },
  formScales: {
    default: ":bar_chart:", // 📊
  },
  departments: {
    default: ":office:", // 🏢
  },
  blog: {
    default: ":blog:",
    compass: ":compass:",
    mega: ":mega:",
    newspaper: ":newspaper:",
    rolled_up_newspaper: ":rolled_up_newspaper:",
    bellhop_bell: ":bellhop_bell:",
    tada: ":tada:",
  },
  scoreCards: {
    default: ":raising_hand:", //
  },
  anonymous: {
    panda: ":panda_face:", // 🐼
    squirrel: ":chipmunk:", // 🐿️
    koala: ":koala:", // 🐨
    penguin: ":penguin:", // 🐧
    bug: ":lady_beetle:", // 🐞
    cow: ":cow:", // 🐮
    shrimp: ":shrimp:", // 🍤
    dragon: ":dragon:", // 🐉
    dog: ":dog:", // 🐕
  },
  task: {
    default: ":heavy_check_mark:", // ✔️
    completed: ":white_check_mark:", // ✅
    archived: ":file_folder:", // 📁
  },
  organizationLink: {
    default: ":owl:", // 🦉
  },
  documentFolders: {
    default: ":open_file_folder:", // 📂
  },
  documents: {
    default: ":card_file_box:", // 🗃️
  },
  workflows: {
    default: ":heavy_check_mark:", // ✔️
  },
};
